import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UsersIcon, ClockIcon } from 'lucide-react';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import { useOrder } from '../../context/OrderContext';
const GroupOrderCreate: React.FC = () => {
  const navigate = useNavigate();
  const {
    createGroupOrder,
    deliveryInfo
  } = useOrder();
  const [formData, setFormData] = useState({
    name: 'Office Lunch',
    paymentType: 'individual',
    expiryHours: '1'
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const groupOrderId = await createGroupOrder({
        name: formData.name,
        individualPayment: formData.paymentType === 'individual',
        expiryHours: parseInt(formData.expiryHours)
      });
      navigate(`/group-order/share/${groupOrderId}`);
    } catch (error) {
      console.error('Failed to create group order:', error);
    }
  };
  return <div className="max-w-3xl mx-auto px-4" data-id="element-525">
      <div className="bg-white rounded-lg shadow-md p-4 sm:p-6" data-id="element-526">
        <div className="flex items-center mb-4 sm:mb-6" data-id="element-527">
          <div className="w-10 h-10 bg-[#E84118] bg-opacity-10 rounded-full flex items-center justify-center mr-3 sm:mr-4" data-id="element-528">
            <UsersIcon size={20} className="text-[#E84118]" data-id="element-529" />
          </div>
          <h1 className="text-lg sm:text-xl font-bold" data-id="element-530">Create Group Order</h1>
        </div>
        {/* Delivery details summary */}
        <div className="bg-gray-50 rounded-md p-3 sm:p-4 mb-5 sm:mb-6" data-id="element-531">
          <h2 className="font-medium mb-2" data-id="element-532">Delivery Details</h2>
          <div className="text-sm text-gray-600" data-id="element-533">
            <p data-id="element-534">Delivery Date: {deliveryInfo?.date || 'Tomorrow'}</p>
            <p data-id="element-535">Meal Type: {deliveryInfo?.mealType || 'Lunch'}</p>
            <p data-id="element-536">Delivery Time: {deliveryInfo?.timeSlot || '11:30 - 12:30'}</p>
          </div>
        </div>
        <form onSubmit={handleSubmit} data-id="element-537">
          <Input label="Group Order Name" name="name" placeholder="e.g. Office Lunch" value={formData.name} onChange={handleChange} required data-id="element-538" />
          <div className="mb-5 sm:mb-6" data-id="element-539">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-540">
              Payment Method
            </label>
            <div className="space-y-2" data-id="element-541">
              <label className="flex items-center" data-id="element-542">
                <input type="radio" name="paymentType" value="individual" checked={formData.paymentType === 'individual'} onChange={handleChange} className="h-4 w-4 text-[#E84118] focus:ring-[#E84118]" data-id="element-543" />
                <span className="ml-2" data-id="element-544">Everyone pays individually</span>
              </label>
              <label className="flex items-center" data-id="element-545">
                <input type="radio" name="paymentType" value="organizer" checked={formData.paymentType === 'organizer'} onChange={handleChange} className="h-4 w-4 text-[#E84118] focus:ring-[#E84118]" data-id="element-546" />
                <span className="ml-2" data-id="element-547">I'll pay for everyone</span>
              </label>
            </div>
          </div>
          <div className="mb-6 sm:mb-8" data-id="element-548">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-549">
              Group Order Expiry
            </label>
            <div className="flex items-center" data-id="element-550">
              <ClockIcon size={18} className="text-gray-400 mr-2" data-id="element-551" />
              <select name="expiryHours" value={formData.expiryHours} onChange={handleChange} className="appearance-none w-full px-3 py-2 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-[#E84118] focus:border-[#E84118]" data-id="element-552">
                <option value="0.5" data-id="element-553">30 minutes</option>
                <option value="1" data-id="element-554">1 hour</option>
                <option value="2" data-id="element-555">2 hours</option>
                <option value="3" data-id="element-556">3 hours</option>
              </select>
            </div>
            <p className="mt-1 text-sm text-gray-500" data-id="element-557">
              The group order will close after this time
            </p>
          </div>
          <Button type="submit" fullWidth size="lg" data-id="element-558">
            Create Group Order
          </Button>
        </form>
      </div>
    </div>;
};
export default GroupOrderCreate;